import React, { useEffect } from 'react'
import ActionCable from 'actioncable'
import { connect, useDispatch } from 'react-redux'
import { WS_ROOT } from '../../../env'
import { patientDocumentsLoad } from '../../../redux/actions/patient/patientDocumentActions'
import Toastr from '../../../itrust_common/components/Toastr'

function DocumentCable(props) {
  const { patientId, filters, onScanComplete, onPageScanned } = props
  const dispatch = useDispatch()

  useEffect(() => {
    let accessToken = localStorage.getItem('Access-Token')
    if (patientId && accessToken && accessToken !== 'null' && accessToken.length > 15) {
      handleActionCableCreate()
    }
  }, [patientId])

  const handleActionCableCreate = () => {
    setTimeout(function () {
      var cable = ActionCable.createConsumer(getWebSocketURL())
      cable.subscriptions.create(
        { channel: 'ScanDeviceChannel' },
        {
          connected: function () {
            console.log('Scan Device Socket Connected')
          },
          disconnected: function () {
            console.log('Scan Device Socket Disconnected')
          },
          received: function (data) {
            data = JSON.parse(data.data)
            if (Number(data.patient_id) !== Number(patientId)) return

            // Multi-page progress — do not reload documents yet.
            if (data.status === 'page_scanned') {
              onPageScanned && onPageScanned(data)
              Toastr.handleShow(true, data.message || `Page ${data.page_count || ''} scanned`)
              return
            }

            onScanComplete && onScanComplete(data)

            if (data.status === 'failed') {
              Toastr.handleShow(false, data.message || 'Failed to scan file')
              return
            }

            dispatch(patientDocumentsLoad(patientId, {
              ...filters,
              include: ['document', 'tags'],
              rpp: 100,
              sort: 'patient_documents.created_at'
            }))
            Toastr.handleShow(true, data.message || 'Document scanned successfully')
          }
        }
      )
    }, 4000)
  }

  const getWebSocketURL = () => {
    const token = localStorage.getItem('Access-Token')
    return `${WS_ROOT}/cable?token=${token}&org=org&ch=app`
  }

  return <></>
}

const mapStateToProps = (state) => ({
  filters: state.filter.filters
})

export default connect(mapStateToProps)(DocumentCable)
